import { ajax } from '../../../services/helper'
class ApiService {

    getAttendanceSummaryData = (date,city_id,kitchen_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/headCount?head_count_date="+date+"&city_id="+city_id+"&kitchen_id="+kitchen_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getHRTicketDetailsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/hrTickets/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
    getBrandGroupsCombo = () =>{
             return new Promise((resolve, reject) => {
            const url = "/v1/brandGroups/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    



    
   

}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Attendance Summary/services/apiservices.js